export var TABLE_ROW_CLASS_PREFIX = 'TableRow';
export var tableRowRootTestId = 'TableRowRoot';